import { Typography } from '@navi/web-ui/lib/primitives';
import { IForeclosureItem } from './interface';
import cx from 'classnames';

const ForeclosureItem = (props: IForeclosureItem) => {
  const {
    title,
    amount,
    preAmount,
    tooltip,
    titleColor = 'var(--navi-color-gray-c3)',
    amountColor = 'var(--navi-color-gray-c1)',
    amountClass,
    showCrossedAmount = false
  } = props;
  return (
    <div className="flex justify-between items-center py-[10px]">
      <div className="flex items-center gap-1">
        <Typography variant="p3" color={titleColor}>
          {title}
        </Typography>
        {tooltip ? tooltip : null}
      </div>
      <div className="flex flex-row gap-2">
        <Typography variant="p3" color={amountColor} className={amountClass}>
          {amount}
        </Typography>
        {showCrossedAmount ? (
          <Typography variant="p3" color={amountColor} className={cx(amountClass, 'line-through')}>
            {preAmount}
          </Typography>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ForeclosureItem;
